
<script>
import { Line } from "vue-chartjs";

export default {
  extends: Line,
  props: {
    chartdata: Array,
    options: Array,
    areaColor: { type: String, default: "" },
    areaColors: { type: Array, default: [] },
    heightChart: { type: Number, default: 150 },
    // rerender:{ type: Boolean, default: true },
    rerender: Boolean,
  },
  data() {
    return {
      gradient: null,
      complete: false,
    };
  },
  mounted() {
    // console.log(this.chartdata);
      this.render();
  },
  methods: {
    render() {
      // console.log("chartdata", this.chartdata);
      if (this.areaColor != "" && this.areaColor[0] == "#") {
        this.gradient = this.$refs.canvas
          .getContext("2d")
          .createLinearGradient(0, 0, 0, this.heightChart);
        let gradientStep1 = this.areaColor;
        let gradientStep2 = this.areaColor + "7a";
        let gradientStep3 = this.areaColor + "00";
        for (let i = 0; i < this.chartdata.datasets.length; i++) {
          this.gradient.addColorStop(0, gradientStep1);
          this.gradient.addColorStop(0.5, gradientStep2);
          this.gradient.addColorStop(1, gradientStep3);
          // console.log(this.gradient);

          this.chartdata.datasets[i].backgroundColor = this.gradient;
        }
      }
      if (this.areaColors.length > 0) {
        for (let i = 0; i < this.chartdata.datasets.length; i++) {
          this.gradient = this.$refs.canvas
            .getContext("2d")
            .createLinearGradient(0, 0, 0, this.heightChart);
          let gradientStep1 = this.areaColors[i];
          let gradientStep2 = this.areaColors[i] + "7a";
          let gradientStep3 = this.areaColors[i] + "00";

          this.gradient.addColorStop(0, gradientStep1);
          this.gradient.addColorStop(0.5, gradientStep2);
          this.gradient.addColorStop(1, gradientStep3);
          // console.log(this.gradient);

          this.chartdata.datasets[i].backgroundColor = this.gradient;
        }
      }

      this.renderChart(this.chartdata, this.options);
      this.complete = true;
    },
  },
  watch: {
    // chartdata() {
    //   // console.log("chartdata updatechart");
    //   // console.log(this.complete);
    //   if (this.complete) {
    //     this.render();
    //   }
    //   // this.$data._chart.update()
    //   // this.renderChart(this.chartdata, this.options);
    //   // this._chart.update();
    // },
    'chartdata.labels':{ // watch it
      handler(newValue, oldValue) {
      console.log('redraw chart',this.chartdata);
      // console.log(newValue, oldValue);
      // this.render();
      this.$data._chart.update()


        // Note: `newValue` will be equal to `oldValue` here
        // on nested mutations as long as the object itself
        // hasn't been replaced.
      },
      deep: true
      },
      'options':{ // watch it
      handler(newValue, oldValue) {
      // console.log('redraw chart',this.chartdata);
      // console.log(newValue, oldValue);
      // this.render();
      this.$data._chart.options =  this.options
      this.$data._chart.update()


        // Note: `newValue` will be equal to `oldValue` here
        // on nested mutations as long as the object itself
        // hasn't been replaced.
      },
      deep: true
      },
      rerender(){
        console.log('rerender',this.heightChart);
        this.render();
      }
  },
  // computed: {
  // chartDataCom: function () {
  // console.log("chartData");
  // this.$data._chart.update();
  // return this.chartdata;
  // },
  // },
};
</script>

<style scoped>
/* .cardBorder {
  border-radius: 20px;
}
.cardBordercolor {
  border-radius: 35px;
  border-style: solid;
  border-color: #6fda79;
}
.stack {
  position: relative;
  top: 15px;
  right: 110px;

} */
</style>